export const API = "https://admin.copeahead.com/api";
export const AUTH_TOKEN = "47e3d434b38ddd02a4182d4953fbda361cde0c21fa5e2e5f5e56de1b2fc815d9781b0f1cdaa6da9d56567eee4820c363d778ccf1fdb1e449b6c422dcca2ac5428c4646cbee59cffefc451be63bf09b01e2d9970ec8d2dc67bd923989e52780610ab10d2800956110039014660cd92885b36b643691cb692e3d47796cd7bf30ed";
export const BEARER = "Bearer";
export const BASE_URL="https://admin.copeahead.com/";
export const IMG_URL="https://www.copeahead.com/";
export const STRIPE_KEY="pk_test_GhEdsltgdfRISZ3HZAR7xuE3";
